// extracted by mini-css-extract-plugin
export default {"container":"ProjectsRoot_container__P6JH3"};